import { createStyles } from '@material-ui/styles'
const styles = ({ breakpoints, bodyFont, white }) =>
    createStyles({
        root: {
            '& a': {
                textDecoration: 'none',
            },
            flexGrow: 1,
            maxWidth: '1440px',
            margin: 'auto',
        },
        headerImg: {
            width: '119px',
        },
        header: {
            padding: '25px 61px',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                padding: '21px 20px',
            },
        },
        regionSetting: {
            display: 'flex',
            gap: '25px',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                gap: '9px',
            },
        },
        starter: {
            width: '100%',
            padding: '53px 18px',
            background: 'rgba(117, 164, 211, 0.4)',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                padding: '33px 18px',
            },
        },
        starterSuccess: {
            width: '100%',
            padding: '72px 50px',
            background: 'rgba(117, 164, 211, 0.4)',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                padding: '33px 20px 44px',
            },
        },
        memberProgram: {
            height: '744px',
            widht: '608px',
            marginTop: '50px',
        },
        becameMember: {
            background: '#FFFFFF',
            padding: '60px 75px',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                padding: '33px 17px',
            },
        },
        becameMemberSuccess: {
            background: '#FFFFFF',
            marginTop: '50px',
            marginBottom: '50px',
            marginRight: '50px',
        },
        umpHeader: {
            //width: "432px",
            //height: "124px",
            //marginLeft: "139px",
            fontStyle: 'normal',
            fontWeight: '600',
            fontSize: '50px',
            '@media(max-width: 600px)': {
                fontSize: '40px',
            },
            lineHeight: '60px',
            color: '#153862',
        },
        bmHeader: {
            marginTop: '37px',
            '& img': {
                width: '300px',
            },
        },
        bmHeaderText: {
            color: '#153862',
            fontSize: '40px',
            fontStyle: 'normal',
            fontWeight: '600',
            '& .member': {
                fontFamily: 'FeelingPassionate',
                fontWeight: '400',
            },
        },
        successBlock: {
            marginLeft: '6%',
        },
        successMember: {
            background: '#FFFFFF',
            //marginRight: "50px",
            width: '500px',
            //marginTop: "50px",
        },
        famImg: {
            padding: '20px',
            marginBottom: '39px',
            '& img': {
                width: '75%',
            },
        },
        familyBG: {
            // width: '100%',
            height: '100%',
            maxHeight: '604px',
            '& img': {
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                [`@media (max-width:${breakpoints.values.sm}px)`]: {
                    objectFit: 'contain',
                },
            },
        },
        successContainer: {
            // maxWidth: '1216px',
            // margin: '0 auto',
        },
        successHeader: {
            fontStyle: 'normal',
            fontWeight: '600',
            fontSize: '50px',
            color: '#153862',
            marginBottom: '48px',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                fontSize: '30px',
                marginBottom: '12px',
            },
        },
        emptyBG: {
            backgroundColor: white,
        },
        footer: {
            padding: '20px',
            background: '#CFACD1',
        },
        footerContent: {
            fontSize: '40px',
            fontWeight: '600',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                fontSize: '30px',
            },
        },
        footerButton: {
            textTransform: 'none',
            backgroundColor: '#FFFFFF',
            borderRadius: '50px',
            marginTop: '40px',
            fontFamily: bodyFont,
            padding: '10px 50px',
            fontSize: '20px',
            color: '#153862',
            fontWeight: '600',
            '&:hover': {
                backgroundColor: '#FFFFFF',
            },
        },
    })

export default styles



// WEBPACK FOOTER //
// ./src/components/StartContainer/start.style.js